import MUIBox from '@/components/MUI-Components/MUI-Box';
import MUIGrid from '@/components/MUI-Components/MUI-Grid';
import MUITypography from '@/components/MUI-Components/MUI-Typography';
import React, {memo} from 'react';
import DisplayImage from '../display-image';
import {colors, spacing} from '@/styles/tokens';

// Migrated from globals.scss `.devops-service-subheading` (+ its `::before` checkmark).
const sxServiceSubheading = {
    marginBottom: spacing[8],
    paddingLeft: spacing[16],
    position: 'relative',
    '&::before': {
        content: '"✔"',
        color: colors.primary.main,
        position: 'absolute',
        left: '-4px'
    }
};

// Migrated from globals.scss `.devops-partner-side-img-wrapper` (+ ipadScreen/tabScreen/600px/320px overrides).
const sxSideImgWrapper = {
    width: '500px',
    height: '100%',
    display: 'grid',
    justifyContent: 'center',
    alignContent: 'center',
    '& img': {
        width: '100%',
        height: 'auto'
    },
    '@media (max-width: 992px)': {
        '& img': {width: '80%'}
    },
    '@media (max-width: 768px)': {
        width: '350px'
    },
    '@media (max-width: 600px)': {
        '& img': {width: '90%'}
    },
    '@media (max-width: 320px)': {
        width: '300px'
    }
};

const DevopsService = (props: any) => {
    const {sideImg, partnerDevopsSummary, heading} = props;
    return (
        <MUIBox>
            <MUIGrid container spacing={3}>
                <MUIGrid xs={12} sm={6} md={6} item>
                    <MUITypography className="devops-buniness-card-heading ">{heading}</MUITypography>
                    <MUIBox className="top-spacing ">
                        {partnerDevopsSummary?.map((item: any, index: number) => (
                            <MUITypography key={index} variant="body2" className="card-content" sx={sxServiceSubheading}>
                                {item?.body}
                            </MUITypography>
                        ))}
                    </MUIBox>
                </MUIGrid>
                <MUIGrid xs={12} sm={6} md={6} item>
                    <MUIBox sx={sxSideImgWrapper}>
                        <DisplayImage src={sideImg} alt="sideImg" />
                    </MUIBox>
                </MUIGrid>
            </MUIGrid>
        </MUIBox>
    );
};

export default memo(DevopsService);
